module.exports = __webpack_public_path__ + "static/media/Nike.41d65e30.png";